import React from "react";

export const SelectArrowIcon = ({ className }) => (
  <svg
    data-testid="select-arrow-icon"
    className={`select-arrow ${className}`}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.64964 8.85441L1.64464 4.82324C1.45179 4.62912 1.45179 4.31206 1.64464 4.11794L2.11393 3.64559C2.30679 3.45147 2.62179 3.45147 2.81464 3.64559L5.99679 6.84206L9.18536 3.64559C9.37821 3.45147 9.69321 3.45147 9.88607 3.64559L10.3554 4.11794C10.5482 4.31206 10.5482 4.62912 10.3554 4.82324L6.34393 8.85441C6.15107 9.04853 5.8425 9.04853 5.64964 8.85441Z"
      fill="currentColor"
    />
  </svg>
);
